export default __webpack_public_path__ + "static/media/right-quote.db3e9c5b.png";